export const isTokenExpired = (expiration: number) => {
  const now = new Date(Date.now());
  const expiresAt = new Date(expiration * 1000);
  return expiresAt <= now ? true : false;
};
